const TestComponent = (data: any) => {
  console.log(data, "test component data");

  return (
    <div
      style={{
        height: "20px",
        width: "100%",
        background: "red",
      }}
    >
      <h1>Test Component</h1>
    </div>
  );
};

export default TestComponent;
